"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var SvgZipLogo = function SvgZipLogo(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return (0, _jsxRuntime.jsxs)("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 196 185",
    fill: "none"
  }, props), {}, {
    children: [title ? (0, _jsxRuntime.jsx)("title", {
      children: title
    }) : null, (0, _jsxRuntime.jsx)("path", {
      d: "M182.48 69.28l-41.22 37.08H39.17a39 39 0 00-25.86 9.76L64.8 69.79l.79-.7L130.1 11a39.16 39.16 0 1152.38 58.23v.05z",
      fill: "#F15C3E"
    }), (0, _jsxRuntime.jsx)("path", {
      d: "M39.17 79.34c21.633 0 39.17-17.537 39.17-39.17C78.34 18.537 60.803 1 39.17 1 17.537 1 0 18.537 0 40.17c0 21.633 17.537 39.17 39.17 39.17z",
      fill: "#F8991C"
    }), (0, _jsxRuntime.jsx)("path", {
      d: "M39.17 106.36a39 39 0 00-25.86 9.76l-.33.3c-16.082 14.464-17.394 39.227-2.93 55.31 14.465 16.083 39.228 17.394 55.31 2.93l75.91-68.29-102.1-.01z",
      fill: "#21285E"
    }), (0, _jsxRuntime.jsx)("path", {
      d: "M141.207 106.39l-75.918 68.29a39 39 0 01-26.189 10h117.127c22.592-.361 38.543-17.358 38.543-39.165s-17.157-38.823-38.543-39.165l-15.02.04z",
      fill: "#00AEB8"
    })]
  }));
};

var _default = SvgZipLogo;
exports["default"] = _default;